import pl from "@locales/patient_files/pl.json";
import en from "@locales/patient_files/en.json";

export default {
  pl: pl,
  en: en,
};
